import React from 'react'

import clsx from 'clsx'

import { IconButton } from 'components/Button'
import { DialogRoot, DialogTitle } from 'components/Dialog'
import Icon from 'components/Icon'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import Autocomplete from './components/Autocomplete'

import classes from './SearchAppDialog.module.scss'

/** @type {import("./types").default} */
const SearchAppDialog = ({ isOpen = false, onClose }) => {
  const { addEvent } = useEventContext()
  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  return (
    <DialogRoot
      className={clsx('SearchAppDialog', classes.root)}
      paperProps={{ className: classes.paper }}
      onClose={handleClose}
      isOpen={isOpen}
    >
      <DialogTitle className={classes.title}>
        <Typography variant="heading-sm">Add an app to compare</Typography>
        <IconButton
          aria-label="close"
          data-testid="dialog-close-button"
          size="small"
          onClick={handleClose}
          {...addEvent({
            engagementComponent: 'compare-basket',
            engagementDestination: 'compare-basket_close-search-modal',
            engagementDetails: 'icon_close-search-modal',
            name: 'engagement_compare_tray',
          })}
        >
          <Icon icon="times" className={classes.closeIcon} size={12} />
        </IconButton>
      </DialogTitle>
      <Autocomplete onClose={onClose} />
    </DialogRoot>
  )
}

export default SearchAppDialog
